import React from "react";

import "./UnorderedList.scss";

export function UnorderedList({ children }: React.PropsWithChildren) {
    return <ul className="unordered-list">{children}</ul>;
}
